<template>
  <el-form-item>
    <template #label>
      <el-select v-model="searchType" :style="selectStyle" :class="selectClass">
        <el-option
          :data-id="key"
          v-for="(obj, key) in selectTypeMap"
          :key="key"
          :label="obj.label"
          :value="key"
        >
          <template v-if="obj.desc">
            {{ obj.label }}
            <el-tooltip placement="right" :content="obj.desc">
              <i class="el-icon-question" />
            </el-tooltip>
          </template>
        </el-option>
      </el-select>
    </template>
    <multiple-input
      ref="textInput"
      v-bind="$attrs"
      v-model="form[searchType]"
      :class="inputClass"
      :style="inputStyle"
      :placeholder="searchText"
      :formatter="selectTypeMap[searchType].formatter"
      @keyup.native.enter="handleSearch"
    ></multiple-input>
  </el-form-item>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { clearKey } from '@/utils/objUtil'
import MultipleInput from '../MultipleInput/index.vue'

export default {
  name: 'SelectInput',
  components: {
    MultipleInput
  },
  props: {
    selectClass: {
      type: [String, Array, Object],
      default: ''
    },
    selectStyle: {
      type: [String, Array, Object],
      default: ''
    },
    inputClass: {
      type: [String, Array, Object],
      default: ''
    },
    inputStyle: {
      type: [String, Array, Object],
      default: ''
    },
    defaultSearchType: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default() {
        return {}
      }
    },
    selectTypeMap: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      searchType: '',
      defaultSearchForm: clearKey(cloneDeep(this.form))
    }
  },
  computed: {
    /**
     * @returns {String}
     */
    searchText() {
      return this.selectTypeMap[this.searchType] ? this.selectTypeMap[this.searchType].placeholder : ''
    }
  },
  watch: {
    searchType(_newVal, oldVal) {
      if (this.form.hasOwnProperty(oldVal)) {
        this.form[oldVal] = this.defaultSearchForm[oldVal]
      }
      this.$emit('update:defaultSearchType', this.searchType)
    },
    defaultSearchType: {
      immediate: true,
      handler(newVal) {
        this.searchType = newVal
      }
    },
  },
  created() {
  },
  methods: {
    focus() {
      this.$refs.textInput.focus()
    },

    handleSearch(evt) {
      this.$emit('pressenter', evt)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .el-select {
    .el-input__suffix-inner {
      pointer-events: none;

      :not(.el-icon-arrow-up) {
        pointer-events: auto;
      }
    }
  }
}
</style>
